// frontend/src/components/dashboards/VendorDashboard/SubCategorySlider.js

import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./subcategorySlider.css";
import MarketplaceProductCard from "./MarketplaceProductCard";

const getImage = (name) =>
  `https://picsum.photos/seed/${encodeURIComponent(name)}/200/200`;

const SUBCATEGORY_DATA = {
  raw: [
  { name: "Cement", image: getImage("cement") },
  { name: "Steel", image: getImage("steel") },
  { name: "Bricks", image: getImage("bricks") },
  { name: "Sand", image: getImage("sand") },
  { name: "Blue Metal", image: getImage("blue-metal") },
  { name: "M-Sand", image: getImage("m-sand") },
  { name: "P-Sand", image: getImage("p-sand") },
  { name: "Gravel", image: getImage("gravel") },
  { name: "Fly Ash", image: getImage("fly-ash") },
  { name: "Ready Mix Concrete", image: getImage("rmc") },
  { name: "AAC Blocks", image: getImage("aac-blocks") },
  { name: "Hollow Blocks", image: getImage("hollow-blocks") },
  { name: "Solid Blocks", image: getImage("solid-blocks") },
  { name: "Red Bricks", image: getImage("red-bricks") },
  { name: "Cement Bricks", image: getImage("cement-bricks") },
  { name: "Kerb Stones", image: getImage("kerb-stones") }
],

  furniture: [
  { name: "Office Furniture", image: getImage("office-furniture") },
  { name: "Home Furniture", image: getImage("home-furniture") },
  { name: "Modular Kitchen", image: getImage("modular-kitchen") },
  { name: "Wardrobes", image: getImage("wardrobes") },
  { name: "Doors", image: getImage("doors") },
  { name: "Windows", image: getImage("windows") },
  { name: "Plywood", image: getImage("plywood") },
  { name: "Laminates", image: getImage("laminates") },
  { name: "Veneers", image: getImage("veneers") },
  { name: "Office Workstations", image: getImage("office-workstations") },
  { name: "Dining Tables", image: getImage("dining-tables") },
  { name: "Chairs", image: getImage("chairs") },
  { name: "Sofas", image: getImage("sofas") },
  { name: "Storage Cabinets", image: getImage("storage-cabinets") }
],
  electrical: [
  { name: "Wires & Cables", image: getImage("wires-cables") },
  { name: "Switches", image: getImage("switches") },
  { name: "MCB", image: getImage("mcb") },
  { name: "DB Boxes", image: getImage("distribution-board") },
  { name: "LED Lights", image: getImage("led-light") },
  { name: "Ceiling Lights", image: getImage("ceiling-light") },
  { name: "Fans", image: getImage("ceiling-fan") },
  { name: "Conduits", image: getImage("electrical-conduit") },
  { name: "Electrical Pipes", image: getImage("electrical-pipe") },
  { name: "Solar Panels", image: getImage("solar-panel") },
  { name: "Inverters", image: getImage("inverter") },
  { name: "Batteries", image: getImage("battery") },
  { name: "Generators", image: getImage("generator") },
  { name: "Smart Switches", image: getImage("smart-switch") }
],

 plumbing: [
  { name: "PVC Pipes", image: getImage("pvc-pipe") },
  { name: "CPVC Pipes", image: getImage("cpvc-pipe") },
  { name: "UPVC Pipes", image: getImage("upvc-pipe") },
  { name: "Water Tanks", image: getImage("water-tank") },
  { name: "Taps", image: getImage("tap") },
  { name: "Faucets", image: getImage("faucet") },
  { name: "Valves", image: getImage("valve") },
  { name: "Bathroom Fittings", image: getImage("bathroom-fitting") },
  { name: "Kitchen Sink", image: getImage("kitchen-sink") },
  { name: "Wash Basin", image: getImage("wash-basin") },
  { name: "Toilet Closet", image: getImage("toilet") },
  { name: "Shower", image: getImage("shower") },
  { name: "Pumps", image: getImage("water-pump") },
  { name: "Borewell Accessories", image: getImage("borewell") }
],

  concrete: [
  { name: "RMC M15", image: getImage("rmc-m15") },
  { name: "RMC M20", image: getImage("rmc-m20") },
  { name: "RMC M25", image: getImage("rmc-m25") },
  { name: "RMC M30", image: getImage("rmc-m30") },
  { name: "RMC M35", image: getImage("rmc-m35") },
  { name: "RMC M40", image: getImage("rmc-m40") },
  { name: "Pump Concrete", image: getImage("pump-concrete") },
  { name: "Self Compacting Concrete", image: getImage("self-compacting-concrete") },
  { name: "Decorative Concrete", image: getImage("decorative-concrete") }
],

  rental: [
  { name: "Centering Sheets", image: getImage("centering-sheet") },
  { name: "Scaffolding", image: getImage("scaffolding") },
  { name: "Props", image: getImage("props") },
  { name: "Tower Ladder", image: getImage("tower-ladder") },
  { name: "Excavator", image: getImage("excavator") },
  { name: "JCB", image: getImage("jcb") },
  { name: "Concrete Mixer", image: getImage("concrete-mixer") },
  { name: "Vibrator", image: getImage("concrete-vibrator") },
  { name: "Earth Rammer", image: getImage("earth-rammer") },
  { name: "Water Tanker", image: getImage("water-tanker") },
  { name: "Crane", image: getImage("crane") },
  { name: "Boom Lift", image: getImage("boom-lift") },
  { name: "Generator", image: getImage("generator") },
  { name: "Compressor", image: getImage("air-compressor") }
]
};

export default function SubCategorySlider({
  products,
  selectedCategory,
  selectedSubCategory,
  setSelectedSubCategory,
}) {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    sliderRef.current?.scrollBy({
      left: -300,
      behavior: "smooth"
    });
  };

  const scrollRight = () => {
    sliderRef.current?.scrollBy({
      left: 300,
      behavior: "smooth"
    });
  };

  const items = [
  ...new Map(
    products
      .filter((p) => p.category === selectedCategory)
      .map((p) => [
        p.subCategory,
        {
          name: p.subCategory,
          image: p.imageUrl || getImage(p.subCategory),
        },
      ])
  ).values(),
];

  return (
    <div className="subcategory-wrapper">

      <button
        className="subcategory-arrow left"
        onClick={scrollLeft}
      >
        <ChevronLeft size={20} />
      </button>

      <div
        className="subcategory-slider"
        ref={sliderRef}
      >
        {items.map((item, index) => (
  <div
    key={`${item.name}-${index}`}
            className={`subcategory-item ${
              selectedSubCategory === item.name ? "active" : ""
            }`}
            onClick={() => setSelectedSubCategory(item.name)}
          >
            <div className="subcategory-image">
              <img
                src={item.image}
                alt={item.name}
                loading="lazy"
              />
            </div>

            <span>{item.name}</span>
          </div>
        ))}
      </div>

      <button
        className="subcategory-arrow right"
        onClick={scrollRight}
      >
        <ChevronRight size={20} />
      </button>

    </div>
  );
}